import React, { Component } from 'react'
import GatsbyLink from '../../../GatsbyLink'
import './RelatedPass.scss'
import Carousel from '../../../Carousel'
import { FaChevronRight } from '../../../../images/icons/FaChevronRight'
import { FaChevronLeft } from '../../../../images/icons/FaChevronLeft'
import PostListItem from '../../PostListItem'
import ProductListItem from '../../ProductListItem'
import { PostListNavigation } from '../../PostListNavigation'
import ls from 'local-storage'
import LazyLoad from 'react-lazy-load'
import { Image } from '../../../Image'
import AddToQuote from '../../../Quote/AddToQuote'
import FaTimes from '../../../../images/icons/FaTimes'

class ThisSlider extends Component {
  render() {
    const {
      posts,
      siteMetadata,
      pathPrefix,
      items = 3,
      showRecent,
    } = this.props
    const settings = {
      container: `related-carousel-${pathPrefix}${showRecent ? '-recent' : ''}`,
      nav: true,
      mouseDrag: true,
      controls: true,
      loop: false,
      gutter: 20,
      slideBy: 1,
      loop: pathPrefix === 'projects' ? true : false,
      speed: 600,
      lazyload: true,
      //controlsContainer: '.related-nav',
      responsive: {
        1600: {
          items: items,
        },
        1024: {
          items: items,
        },
        640: {
          items: items,
        },
        420: {
          items: 1,
        },
      },
    }

    return (
      <div className="slider">
        <Carousel settings={settings}>
          {posts &&
            posts.map((post, slide_count) =>
              post.node.slug !== 'gatsby' && pathPrefix === 'products' ? (
                <ProductListItem
                  key={slide_count}
                  data={post.node}
                  siteMetadata={siteMetadata}
                  pathPrefix={pathPrefix}
                />
              ) : (
                <PostListItem
                  key={slide_count}
                  data={post.node}
                  siteMetadata={siteMetadata}
                  pathPrefix={pathPrefix}
                  lazy={false}
                />
              )
            )}
        </Carousel>
      </div>
    )
  }
}

class ListView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeProduct: null,
      activeImage: null,
    }
  }

  quickAdd = (event, data) => {
    this.setState({ activeProduct: data })
  }

  updateActiveImage = image => {
    if (image.source_url) {
      this.setState({ activeImage: image })
    }
  }

  closeModal = event => {
    event.preventDefault()
    this.setState({ activeProduct: null, activeImage: null })
  }

  showModal = activeProduct => {
    const { acf, wordpress_id, featured_media, title } = activeProduct
    const { activeImage } = this.state
    const { colours, productVariations } = acf
    const firstImage = activeImage ? activeImage : featured_media
    const productOptions = {
      colours: colours,
      variations: productVariations,
    }
    return (
      <div className="product-modal">
        <div className="wrap">
          <FaTimes
            className="close"
            onClick={event => this.closeModal(event)}
          />
          <div className="inner">
            <span
              className="product-title h1"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            {firstImage && (
              <div className="image">
                <div className="aspect">
                  <Image className="image" src={firstImage} lazyLoad={true} />
                </div>
              </div>
            )}
            <AddToQuote
              options={productOptions}
              productId={wordpress_id}
              updateActiveImage={this.updateActiveImage}
            />
          </div>
        </div>
      </div>
    )
  }
  render() {
    const { posts, siteMetadata, pathPrefix } = this.props
    const { activeProduct } = this.state
    return (
      <div className="slider list-view">
        {activeProduct && this.showModal(activeProduct)}
        {posts &&
          posts.map((post, slide_count) =>
            post.node.slug !== 'gatsby' && pathPrefix === 'products' ? (
              <ProductListItem
                key={slide_count}
                data={post.node}
                siteMetadata={siteMetadata}
                pathPrefix={pathPrefix}
                quickAdd={this.quickAdd}
              />
            ) : (
              <PostListItem
                key={slide_count}
                data={post.node}
                siteMetadata={siteMetadata}
                pathPrefix={pathPrefix}
                quickAdd={this.quickAdd}
              />
            )
          )}
      </div>
    )
  }
}

export const RelatedPass = props => {
  const {
    data,
    posts,
    title = 'Related Posts',
    listView,
    contentType = 'blog',
    action = { url: `/blog/`, title: 'View all' },
    categoryFilter,
    postFilter,
    items,
    showRecent,
  } = props
  const pathPrefix = contentType
  const { edges: postsPass } = posts
  const recentPosts = ls.get('viewedProducts')
  const filterByWhat = showRecent && recentPosts ? recentPosts : postFilter
  const returnPosts =
    postsPass && filterByWhat
      ? postsPass.filter(a => filterByWhat.includes(a.node.wordpress_id))
      : postsPass
  if (returnPosts.length <= 0) return null
  return (
    <LazyLoad
      className={`post-feed ${contentType}-list${listView ? ' list-view' : ''}`}
      offsetBottom={100}
      debounce={false}
    >
      <div className="wrap">
        <div className="intro">
          {title && (
            <span
              className="title section-title h3"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
        </div>

        {!listView && (
          <ThisSlider
            posts={returnPosts.slice(0, 6)}
            pathPrefix={pathPrefix}
            items={items}
            showRecent={showRecent}
          />
        )}

        {listView && <ListView posts={returnPosts} pathPrefix={pathPrefix} />}

        {action && (
          <div className="link__wrapper">
            <GatsbyLink
              to={action.url}
              aria-label={action.title}
              className="link"
            >
              {action.title}
            </GatsbyLink>
          </div>
        )}
      </div>
    </LazyLoad>
  )
}
